import { useContext, useState } from 'react';
import { ContainerContext } from './ContainerContext';
import { interfaces } from 'inversify';
import ServiceIdentifier = interfaces.ServiceIdentifier;

export function useService<T>(serviceName: ServiceIdentifier<T>): T {
    const { container } = useContext(ContainerContext);
    const [result] = useState(container.get<T>(serviceName));
    return result;
}
